import { render, staticRenderFns } from "./Area51.vue?vue&type=template&id=d62491a0&"
import script from "./Area51.vue?vue&type=script&lang=js&"
export * from "./Area51.vue?vue&type=script&lang=js&"
import style0 from "./Area51.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports